import styled from "styled-components";

export const MobileFiltersWrapper = styled.div`
  display: flex;
  justify-content: center;
  transform: ${(props) =>
    props.visible ? "translateX(0)" : "translateX(-100%)"};
  transition: all 0.4s linear;
  z-index: 1;
  position: fixed;
  overflow: scroll;
  top: 0px;
  right: 0px;
  width: 100%;
  height: 100%;
  background: #f5f5f5;


  .small-img {
    width: 100px;
    height: 93px;
  }

  .control-div span {
    font-size: 16px;
    color: #2d2b2d;
  }

  .btn-control {
    margin-top: 50px;
  }

  .control-div h6 {
    color: #d10727;
    font-weight: bold;
    font-size: 14px;
  }

  .control-div {
    margin-top: 45px;
  }

  .bg-colori {
    background: #f7f7f7;
    padding: 10px;
  }
`;
